import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const AchievementsPage = lazy(async () => {
  const m = await import("@/features/gamification/components/achievements-page");
  return { default: m.AchievementsPage };
});

/**
 * GAMIFICATION-CORE (UI) — "Achievements": XP/level, streak and badges derived from feed
 * activity. Opt-in and non-punitive (B2B, team-oriented); private leagues
 * by default (does not show comparisons between individuals).
 */
export const achievementsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/achievements",
  component: () => (
    <Suspense fallback={null}>
      <AchievementsPage />
    </Suspense>
  ),
});
